



























































































































































































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		mois: {
			type: Number,
			default: 1
		},
		height: {
			type: Number,
			default: 330
		}
	},
	data: function() {
		return {
			isDisplayAfficherMoins: false,
			isDisplayAfficherPlus: true,
			maxHeight: this.height + 'px',
			minHeight: this.height + 'px'
		};
	},
	watch: {
		// Initialise la taille du block (330px par defaut) quand le mois sélectionné change
		mois: function(newVal, oldVal) {
			this.maxHeight = this.height + 'px';
			this.minHeight = this.height + 'px';
		}
	},
	mounted() {
		this.afficherBoutonPlusOuMoins();
	},
	updated() {
		this.updatedBoutonPlusOuMoins();
	},
	created() {
		window.addEventListener('resize', this.afficherBoutonPlusOuMoins);
	},
	methods: {
		// Test si l'age sélectionné contient le paragraphe sur les voyages
		isVoyage: function() {
			let json: any = this.$t('components.santeenfant.vaccins.mois'+ this.mois);
			if (json.voyage) {
				return true;
			}
			return false;
		},
		// Test si l'age sélectionné contient le paragraphe sur les vaccins à faire
		isParagrapheAFaire: function() {
			let json: any = this.$t('components.santeenfant.vaccins.mois'+ this.mois);
			if (json.afaire) {
				return true;
			}
			return false;
		},
		// Test si l'age sélectionné contient le paragraphe sur les prochains vaccins
		isProchainVaccin: function() {
			let json: any= this.$t('components.santeenfant.vaccins.mois'+ this.mois);
			if (json.prochainexamens) {
				return true;
			}
			return false;
		},
		// Test si l'age sélectionné dispose d'une image pour les prochains vaccins
		isImageProchainVaccin: function(translate: any) {
			let json: any = this.$t(translate);
			if (json.image) {
				return true;
			}
			return false;
		},
		afficherMoins: function() {
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.maxHeight = this.height + 'px';
		},
		afficherPlus: function() {
			this.isDisplayAfficherPlus = !this.isDisplayAfficherPlus;
			this.isDisplayAfficherMoins = !this.isDisplayAfficherMoins;
			this.maxHeight = 'inherit';
		},
		updatedBoutonPlusOuMoins: function() {
			if (window.innerWidth > 760) {
				// Si la taille du block est supérieur à la taille du contenu
				if (this.height >= (this.$refs.VCardVaccin as Vue).$el.scrollHeight) {
					//On n'affiche pas les bouton afficher moins et plus
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
					this.maxHeight = this.height + 'px';
				} else {
					// Si le block est déjà déroulé
					if (this.maxHeight == 'inherit') {
						// On affiche le bouton afficher moins
						this.isDisplayAfficherMoins= true;
						this.isDisplayAfficherPlus= false;
					} else {
						// On affiche le bouton afficher plus
						this.isDisplayAfficherMoins= false;
						this.isDisplayAfficherPlus= true;
					}
				}
			}
		},
		afficherBoutonPlusOuMoins: function() {
			// si la fenêtre fait moins de 760 px
			if (window.innerWidth < 760) {
				// block dérouler et on affiche pas les boutons afficher plus et moins
				this.minHeight = 'inherit';
				this.maxHeight = 'inherit';
				this.isDisplayAfficherMoins= false;
				this.isDisplayAfficherPlus= false;
			} else {
				this.minHeight = this.height + 'px';
				this.maxHeight = this.height + 'px';
				// Si la taille du block est supérieur à la taille du contenu
				if (this.height >= (this.$refs.VCardVaccin as Vue).$el.scrollHeight) {
					//On n'affiche pas les bouton afficher moins et plus
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= false;
				} else {
					// On affiche le bouton afficher plus
					this.isDisplayAfficherMoins= false;
					this.isDisplayAfficherPlus= true;
				}
			}
		}
	}
});

@Component
export default class Vaccins extends Props {
}
